import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import axios from 'axios';
import EditUserModal from './editUserModal';
import CreateUserModal from './createUserModal';
import { kinetik_api_url } from '../../utilities/const';
import WindowAlert from '../../common/AlertComponent';


class UsersPage extends Component {
    constructor(props){
        super(props);
        this.state = {
            showUserEditingModal: false,
            showUserCreatingModal: false,
            isUserListUpdated: false,
            userListData: [],
            editingUserData: {},
            isdeleteInfoUpdated: false,
            messageType: '',
            message: ''
        };
    }

    componentDidMount() {
        let token = localStorage.getItem('authToken');
        let userType = localStorage.getItem('userType');
        let URL = kinetik_api_url + '/list_users?token=' + token + '&userType=' + userType;

        axios.get(URL)
        .then( (result) => {
            this.setState({
                isUserListUpdated: true,
                userListData: result.data
            })
        })
        .catch( (err) => {
            console.log(err);
        })
    }

    hideOrShowEditingModal = (data={}) => {
        this.setState({
            showUserEditingModal: this.state.showUserEditingModal ? false : true,
            editingUserData: data
        });
        // this.handleData(data);
    }
    hideOrShowCreatingModal = () => {
        this.setState({
            showUserCreatingModal: this.state.showUserCreatingModal ? false : true,
        });
        // this.handleData(data);
    }

    onUserCreated = () => {
        let token = localStorage.getItem('authToken');
        let userType = localStorage.getItem('userType');
        let URL = kinetik_api_url + '/list_users?token=' + token + '&userType=' + userType;

        axios.get(URL)
        .then( (result) => {
            this.setState({
                isUserListUpdated: true,
                userListData: result.data
            })
        })
        .catch( (err) => {
            console.log(err);
        })
    }

    handleDelete = (user_id) => {
        let token = localStorage.getItem('authToken');
        let userType = localStorage.getItem('userType');
        let URL = kinetik_api_url + '/delete_user?token=' + token + '&userType=' + userType + '&user_id='+user_id;

        

        if(window.confirm("Are you sure that you want to delete this user?")) {
            axios.delete(URL)
            .then((result) => {
                let newUserList = this.state.userListData.filter((v) => v.user_id !== user_id);
                this.setState({
                    messageType: result.data.status,
                    message: result.data.message,
                    isdeleteInfoUpdated: true,
                    userListData: newUserList
                });
            })
            .catch((err) => {
                this.setState({
                    messageType: "error",
                    message: err.data.message,
                    isdeleteInfoUpdated: true
                });
            })
        }
    }

    handleAlert = () => {
        this.setState({
            isdeleteInfoUpdated: false
        })
    }

    render () {

        const userPrevName = (raw) => {
            switch (raw) {
                case 1:
                    return 'Admin'
                case 2:
                    return 'Manager'
                case 3:
                    return 'Standard'
            
                default:
                    return ""
            }
        }

        let UserList = [];
        if (this.state.isUserListUpdated) {
            UserList = this.state.userListData.map( (v, k) => (
                <tr key={k}>
                    <td>{v.user_id}</td>
                    <td>{v.first_name} {v.last_name}</td>
                    <td>{userPrevName(v.user_type)}</td>
                    <td> <i className="fa fa-edit edit_ico_us" onClick={() => this.hideOrShowEditingModal(v)} /> <span onClick={() => this.handleDelete(v.user_id)} className="item_btn_usr_del"> ✕ </span></td>
                </tr>
            ));
        }
        return (
            <div className="row">
                <div className="col-md-3"></div>
                <div className="col-md-6">
                    <div className="users_on_settings">
                        <h4 className="users_setti_h_title">
                            Add/Edit/Remove Users
                        </h4>
                        <Table responsive={true} className="user_settin_ta">
                            <thead>
                                <tr>
                                    <th>User ID</th>
                                    <th>Name</th>
                                    <th>User Type</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {UserList}
                            </tbody>
                        </Table>
                        <div className="update_profile_btn">
                            <input onClick={this.hideOrShowCreatingModal} type="submit" className="settings_update_btn" id="submit_box" value="ADD NEW USER" />
                        </div>
                    </div>
                </div>
                <div className="col-md-3"></div>

                {/* Modals for USer Editing */}
                <EditUserModal 
                    show={this.state.showUserEditingModal}
                    hideOrShowEditingModal={this.hideOrShowEditingModal}
                    userData={this.state.editingUserData}
                />
                {/* For creating New User */}
                <CreateUserModal 
                    show={this.state.showUserCreatingModal}
                    hideOrShowEditingModal={this.hideOrShowCreatingModal}
                    onUserCreated={this.onUserCreated}
                />

                <WindowAlert
                    show={this.state.isdeleteInfoUpdated}
                    messageType={this.state.messageType}
                    text={this.state.message}
                    onCofirm={this.handleAlert}
                />
            </div>
        )
    }
}

export default UsersPage;


// WEBPACK FOOTER //
// ./src/app/profile_settings/users/usersPage.js